import {AnyAction} from 'redux';
import {SET_REGISTRY} from '../actionTypes';

export interface RegistryState {
  firstName: string;
  middleName: string;
  firstLastName: string;
  secondLastName: string;
  birthDate: string;
  city: string;
  province: string;
}

const initialState: RegistryState = {
  firstName: '',
  middleName: '',
  firstLastName: '',
  secondLastName: '',
  birthDate: '',
  city: '',
  province: '',
};

const registry = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_REGISTRY:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default registry;
